module.exports = __webpack_public_path__ + "img/9788960514782.9177a18a.jpg";